import { useEffect } from 'react'

import { useSetState } from '~/hooks/useSetState'
import { useRecentlyClaimed } from '~/lib/useRecentlyClaimed'

import { CROSSCHAIN_CONFIG } from './config'
import { useWallet } from './useWallet'

export type ClaimData = {
	account: string
	amount: string
	index: number
	proofs: string[]
}

interface State {
	claimData: ClaimData | null
	claimDataPending: boolean
}

export function useClaimData(url = CROSSCHAIN_CONFIG.farming.url) {
	const { account } = useWallet()

	const [state, setState] = useSetState<State>({
		claimData: null,
		claimDataPending: false,
	})

	const { isRecentlyClaimed } = useRecentlyClaimed()

	useEffect(() => {
		if (!account) return

		setState({ claimDataPending: true })

		fetch(`${url}/v1/users/${account}`, {
			method: 'get',
		})
			.then((response) => {
				if (response.status !== 200) {
					throw new Error('Get total rewards failed')
				}

				return response.json()
			})
			.then((data: ClaimData) => {
				setState({
					claimData: {
						...data,
						amount: isRecentlyClaimed ? '0' : data.amount,
					},
					claimDataPending: false,
				})
			})
			.catch((error) => {
				console.warn(error)
				setState({
					claimData: {
						amount: '0',
					} as ClaimData,
					claimDataPending: false,
				})
			})
	}, [account, setState, isRecentlyClaimed])

	const { claimData, claimDataPending } = state

	return { claimData, claimDataPending }
}
